module.exports = __webpack_public_path__ + "img/logoh.5fa82ff7.jpg";